import React from 'react';

import { useDrag, DragPreview, useDrop } from '@react-aria/dnd';
import ZutatenFormTableRow from './ZutatenFormTableRow';

const MIME_TYPE = 'zutaten-form-table-row';

const ZutatenFormTableRowDraggable = ({
  zutat,
  index,
  rohstoffeNames,
  produkteNames,
  zutatengruppen,
  grundrezepte,
  zutatenLength,
  // handleKeyDown,
  handleZutatChange,
  handleSortUp,
  handleSortDown,
  handleSortDrop,
  dndId,
  removeZutat,
}) => {
  const row = React.useRef(null);
  const [rowHeight, setRowHeight] = React.useState(0);
  const [isFirstHalf, setFirstHalf] = React.useState(true);

  const rowNode = (node) => {
    if (node) {
      setRowHeight(node.getBoundingClientRect().height);
    }
    row.current = node;
  };

  const preview = React.useRef(null);

  const { dragProps, isDragging } = useDrag({
    preview,
    getItems() {
      return [
        {
          'zutaten-form-table-row': JSON.stringify({
            index: index,
            dndId: dndId,
          }),
        },
      ];
    },
  });

  const setPositionWithinDropTarget = (evt) => {
    const newFirstHalf = evt.y < rowHeight / 2;
    if (rowHeight > 0 && newFirstHalf !== isFirstHalf) {
      setFirstHalf(newFirstHalf);
    }
    return newFirstHalf;
  };

  const unquote = (str) => str.replace(/^'(.*)'$/, '$1');

  const onDropping = (evt) => {
    setPositionWithinDropTarget(evt);
  };
  const onDrop = async (evt) => {
    const firstHalf = setPositionWithinDropTarget(evt);
    let items = await Promise.all(
      evt.items
        .filter((item) => item.kind === 'text' && item.types.has(MIME_TYPE))
        .map(async (item) =>
          JSON.parse(unquote(await item.getText(MIME_TYPE))),
        ),
    );
    if (items.length === 0) return;
    // We only support one item being dragged at a time
    const item = items[0];
    // Match for dndId to avoid dragging from other lists and pages
    if (item.dndId !== dndId) return;
    const dragIndex = item.index;
    const dropIndexSlot = firstHalf ? index : index + 1;
    const dropIndex =
      dropIndexSlot > dragIndex ? dropIndexSlot - 1 : dropIndexSlot;
    handleSortDrop(dragIndex, dropIndex);
  };

  const { dropProps, isDropTarget } = useDrop({
    ref: row,
    onDropEnter: onDropping,
    onDropMove: onDropping,
    onDrop,
  });

  const dropClass = isDropTarget
    ? rowHeight > 0 && isFirstHalf
      ? ' drop-target-top'
      : ' drop-target-bottom'
    : '';

  return (
    <>
      <div ref={rowNode} className={`row-container ${dropClass}`}>
        <ZutatenFormTableRow
          key={index}
          zutat={zutat}
          zutatengruppen={zutatengruppen}
          index={index}
          zutatenLength={zutatenLength}
          rohstoffeNames={rohstoffeNames}
          produkteNames={produkteNames}
          grundrezepte={grundrezepte}
          handleZutatChange={handleZutatChange}
          handleSortUp={handleSortUp}
          handleSortDown={handleSortDown}
          handleSortDrop={handleSortDrop}
          removeZutat={removeZutat}
          dragProps={dragProps}
          dropProps={dropProps}
        />
      </div>
      <DragPreview ref={preview}>
        {(items) => (
          <div className="zutaten-form-drag-preview">
            <ZutatenFormTableRow
              zutat={zutat}
              index={index}
              zutatenLength={zutatenLength}
              rohstoffeNames={rohstoffeNames}
              produkteNames={produkteNames}
              grundrezepte={grundrezepte}
            />
          </div>
        )}
      </DragPreview>
    </>
  );
};

export default ZutatenFormTableRowDraggable;
